import "date-fns";
import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";

import Box from "@material-ui/core/Box";

import {
  DatePicker as DateOnlyPicker,
  TimePicker,
  DateTimePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";

import colors from "../../assets/style/colors";
import images from "../../assets/img/images";

const styles = {
  textField: {
    width: "100%",
    margin: 0,
    backgroundColor: colors.white,
  },
  input: {
    height: "36px",
  },
  inputElement: {
    padding: "9.5px 10px",
  },
  inputSize: {
    fontSize: "0.875em",
    backgroundColor: colors.white,
  },
};

const DatePicker = (props) => {
  const { classes, dateOnly = false, timeOnly = false } = props;
  if (timeOnly) {
    console.log(props.value)
  }
  return (
    <Box style={{ marginBottom: "16px", maxWidth: "100%", ...props.style }}>
      <Box className="text-87 bold-500">{props.label}</Box>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        {dateOnly ? (
          <DateOnlyPicker
            className={classes.textField}
            inputVariant="outlined"
            margin="dense"
            value={props.value}
            onChange={(date) => props.onChange(props.name, date)}
            format="dd/mm"
            InputProps={{
              className: classes.input,
              classes: { input: classes.inputSize },
              startAdornment: (
                <img
                  src={images.calendarIcon}
                  width="14px"
                  alt="calendarIcon"
                />
              ),
            }}
            inputProps={{
              className: classes.inputElement,
            }}
            style={{ width: props.width || "" }}
            labelFunc={props.formatLabel}
          />
        ) : timeOnly ? (
          <TimePicker
            className={classes.textField}
            inputVariant="outlined"
            margin="dense"
            value={props.value}
            onChange={(date) => props.onChange(props.name, date)}
            InputProps={{
              className: classes.input,
              classes: { input: classes.inputSize },
            }}
            inputProps={{
              className: classes.inputElement,
            }}
            style={{ width: props.width || "" }}
            labelFunc={props.formatLabel}
          />
        ) : (
          <DateTimePicker
            className={classes.textField}
            inputVariant="outlined"
            margin="dense"
            value={props.value}
            onChange={(date) => props.onChange(props.name, date)}
            InputProps={{
              className: classes.input,
              classes: { input: classes.inputSize },
            }}
            inputProps={{
              className: classes.inputElement,
            }}
            style={{ width: props.width || "" }}
          />
        )}
      </MuiPickersUtilsProvider>
    </Box>
  );
};

DatePicker.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default withStyles(styles)(DatePicker);
